$(document).ready(function(){
    var sections = $('.sidenav--section')
      , nav = $('.sidenav--links')
      , nav_height = $('#master').outerHeight();

    $(window).on('scroll', function () {
      var cur_pos = $(this).scrollTop();

      sections.each(function() {
        var top = $(this).offset().top - nav_height,
            bottom = top + $(this).outerHeight();

        if (cur_pos >= top && cur_pos <= bottom) {
          nav.find('.anchor--link').removeClass('active');
          sections.removeClass('active');

          $(this).addClass('active');
          nav.find('a[href="#'+$(this).attr('id')+'"]').addClass('active');
        }
      });
    });

    // nav.find('.anchor--link').on('click', function (e) {
    //     // e.preventDefault();
    //
    //   var $el = $(this)
    //     , id = $el.attr('href');
    //
    //     e.preventDefault()
    //
    //   $('html, body').animate(
    //     {
    //       scrollTop: $(id).offset().top - nav_height,
    //     },
    //     500,
    //     'linear'
    //   )
    //
    //
    //   // $('html, body').animate({
    //   //   scrollTop: $(id).offset().top - nav_height
    //   //   }, 1000, 'linear');
    //
    //   return false;
    // });
})
